import { render, staticRenderFns } from "./pcContent.vue?vue&type=template&id=68a0e032&scoped=true"
import script from "./pcContent.vue?vue&type=script&lang=js"
export * from "./pcContent.vue?vue&type=script&lang=js"
import style0 from "./pcContent.vue?vue&type=style&index=0&id=68a0e032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a0e032",
  null
  
)

export default component.exports